export default "__VITE_ASSET__Doe7ZrUe__"